import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from './Home';
import './App.css';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Services from "./Services";
import About from "./About";
import ContactUs from "./ContactUs";
import DiscountOffer from "./offer";
import Whatsapp from "./whatsapp";

const App = () => {

  return (
    <>
      <Whatsapp />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contact" element={<ContactUs />} />
        </Routes>
        <DiscountOffer />
      </BrowserRouter>

      <ToastContainer
        position="top-right"
        autoClose={10000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      /></>
  )
}

export default App;
